module.exports = __webpack_public_path__ + "img/story005.93d80263.webp";